import {
  permissionsUsersReadonly,
  permissionsTenantsReadonly,
  permissionsLocationsReadonly,
  permissionsSettings,
} from "@/utils";

export const permissionsPartnerMenu = [
  ...permissionsUsersReadonly,
  ...permissionsTenantsReadonly,
  ...permissionsLocationsReadonly,
  ...permissionsSettings,
];
